/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IconService } from '@nrwl/icon-services';

@Component({
  selector: 'rx-icon',
  templateUrl: './rx-icon.component.html',
  styleUrls: ['./rx-icon.component.scss'],
  imports: [CommonModule, MatIconModule],
  standalone: true,
})
export class RxIconComponent implements OnInit {
  @Input() name: string | any;
  @Input() color: string | any;
  @Input() config: any;
  @Input() size: any;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private iconService: IconService,
  ) {}

  ngOnInit() {
    if (this.name) {
      this.iconService.register(this.name);
      // this.matIconRegistry.addSvgIcon(
      //     this.name,
      //     this.sanitizer.bypassSecurityTrustResourceUrl(
      //         `assets/icons/${this.name}.svg`
      //     )
      // );
    }
  }
}
